import type { Quiz409Translations } from './quizExpired.translation.pl.ts';

export const quizToManyRevisitsTranslations: Quiz409Translations = {
  title: 'Oups ! Trop de tentatives !',
  subMessage:
    "Cette année, tu n'as pas réussi à terminer toutes les tâches de qualification. Tu ne peux plus te connecter.",
  buttons: {
    back: 'Accueil',
  },
};
